import React, { Component } from 'react';
import PropTypes from 'prop-types';

/** Core */
import { Pill, PillText } from '../../../core/Pill';
import Loading from '../../../core/Loading';

/** Styles */
import { StyledTraining, StyledTwoLevelBreadcrumb } from './style';

/** Constants */
import { MENU } from '../../../../constants/training';

// eslint-disable-next-line no-unused-vars
function toggle(action) {
  if (action === 'open') {
    document.getElementById('trainingIframe').classList.add('open');
  } else {
    document.getElementById('trainingIframe').classList.remove('open');
  }
}

class Training extends Component {
  constructor(props) {
    super(props);

    this.state = {
      trainingSection: undefined
    };
  }

  setUrlTraining = item =>
    this.setState({
      trainingSection: item
    });

  render() {
    const { trainingSection } = this.state;
    const { className } = this.props;
    const prod = window.API_URL === 'https://intranetapi.atresmedia.com/';

    return (
      <StyledTraining className={className}>
        {trainingSection ? (
          <div className="wrapper-iframe">
            <StyledTwoLevelBreadcrumb
              first="Formación"
              second={trainingSection.title}
              onBack={() =>
                this.setState({
                  trainingSection: undefined
                })
              }
            />
            <Loading
              className="preload"
              txt={`Cargando ${trainingSection.title}`}
            />
            <iframe
              id="trainingIframe"
              src={prod ? trainingSection.urlProd : trainingSection.url}
              title={trainingSection.title}
              width="100%"
              height="100%"
              className="iframe-training"
            />
          </div>
        ) : (
          <div className="wrapper-pill">
            {MENU.map(item => (
              <Pill onClick={() => this.setUrlTraining(item)} key={item.title}>
                <PillText>{item.title}</PillText>
              </Pill>
            ))}
          </div>
        )}
      </StyledTraining>
    );
  }
}

Training.propTypes = {
  className: PropTypes.string
};

export default Training;
